// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y_JZ","rootMobile":"styles_rootMobile__3CiwU"};